import config from 'constants/config';
import api from '../api';

const loginUrl = api.config.login();
const { serviceUrl } = config;

function login(username, password) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: username, password: password })
  };
  return fetch(loginUrl, requestOptions);
}

const unleashDetails = async (username) => {
  const unleashApiUrl =
    (serviceUrl?.includes('localhost') || serviceUrl?.includes('qa'))
      ? `https://www.qa.thermofisher.com/api/store/frontend?appName=documentmanager&environment=development&userName=${username}`
      : `https://www.thermofisher.com/api/store/frontend?appName=documentmanager&environment=production&userName=${username}`;
  

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  };

  const response = await fetch(unleashApiUrl, requestOptions);
  return response;
};

const getUserType = async () => {
  console.log('serviceUrl', serviceUrl);
  const userTypeUrl =
    (serviceUrl?.includes('localhost') || serviceUrl?.includes('qa'))
      ? 'https://www.qa.thermofisher.com/api/store/user-type'
      : 'https://www.thermofisher.com/api/store/user-type';

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  };

  const response = await fetch(userTypeUrl, requestOptions);
  return response;
};

export const userService = {
  login,
  unleashDetails,
  getUserType
};
